"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUserTimingPlugin = void 0;

var _performance = require("../utilities/performance");

function getUserTiming(fromTime) {
  var marks = (0, _performance.getEntriesByType)(_performance.EntryType.MARK);
  var measures = (0, _performance.getEntriesByType)(_performance.EntryType.MEASURE);
  var entries = marks.concat(measures).filter(function (entry) {
    return entry.startTime + entry.duration >= fromTime;
  });

  if (!entries.length) {
    return undefined;
  }

  var userTiming = {};
  entries.forEach(function (entry) {
    if (entry.entryType === 'mark') {
      userTiming.mark = userTiming.mark || {};
      userTiming.mark[entry.name] = entry.startTime;
    } else if (entry.entryType === 'measure') {
      userTiming.measure = userTiming.measure || {};
      userTiming.measure[entry.name] = entry.duration;
    }
  });
  return JSON.stringify(userTiming);
}
/**
 * A plugin responsible for collecting metrics from the User Timing API.
 *
 * This plugin collects all marks and measures that were added since
 * navigation start or since the last beacon fired for the current navigation.
 *
 * This plugin adds the following parameters to the beacon:
 *
 * - `userTiming`: A plain object containing the collected marks and measures.
 *
 * Timing data is rounded to the nearest millisecond.
 *
 * For example:
 *
 * ```javascript
 * // mark current timestamp as mark1
 * performance.mark('mark1');
 * // mark current timestamp as mark2
 * performance.mark('mark2');
 * // measure1 will be the delta between mark1 and mark2 timestamps
 * performance.measure('measure1', 'mark1', 'mark2');
 * // measure2 will be the delta between the mark2 timestamp and the current time
 * performance.measure('measure2', 'mark2');
 * ```
 *
 * The data added to the beacon will look similar to the following:
 *
 * ```
 * userTiming={"mark":{"mark1":100,"mark2":200},"measure":{"measure1":100,"measure2":200}}
 * ```
 *
 * @see http://www.w3.org/TR/user-timing/
 */


var createUserTimingPlugin = function createUserTimingPlugin() {
  return function (_ref) {
    var addVariable = _ref.addVariable;
    var fromTime = 0;
    return {
      beaconWillSendData: function beaconWillSendData() {
        try {
          var now = window.performance.now();
          var userTiming = getUserTiming(fromTime);

          if (userTiming != null) {
            addVariable('userTiming', userTiming, true);
          }

          fromTime = now;
        } catch (error) {// Do nothing.
        }
      }
    };
  };
};

exports.createUserTimingPlugin = createUserTimingPlugin;